// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"44b6e1e2","682":"4350a207","687":"f2ca3db8","836":"6937c31b","924":"b828a13d","992":"bcbbbb00"}[chunkId] + ".chunk.js";
};